import { AppRoutes } from '@/routes';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

export default function Error404Page() {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button type="primary" onClick={() => navigate(AppRoutes.DASHBOARD_ROUTE)}>
          Back Home
        </Button>
      }
    />
  );
}
